module.exports = __webpack_public_path__ + "static/media/CHei2-Bold-HKSCS.1deee9d4.svg";